<template>
    <section class="cnc-services-section">
        <div class="container">
            <h2 class="section-title">Die Casting Processes</h2>
            <div class="services-grid">
                <div 
                    class="service-card" 
                    v-for="(item, index) in serviceList" 
                    :key="index"
                >
                    <div class="card-image">
                        <img :src="item.image" :alt="item.title" />
                    </div>
                    <div class="card-content">
                        <h3 class="card-title">{{ item.title }}</h3>
                        
                        <div class="card-desc-wrapper">
                            <p 
                                class="card-desc" 
                                :class="{ expanded: item.isExpanded }"
                            >
                                {{ item.desc }}
                            </p>
                            
                            <button 
                                v-if="item.desc.length > 120" 
                                class="toggle-btn"
                                @click.stop="toggleDesc(index)"
                            >
                                {{ item.isExpanded ? 'Show Less' : 'Read More' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="action-buttons">
                <button class="btn-primary" @click="$router.push('/quote')">Get Instant Quote</button>
            </div>
        </div>
    </section>
</template>

<script>
import { ref } from 'vue'
export default {
    name: 'Die_Services',
    setup() {
        const serviceList = ref([
            {
                image: require('@/assets/process/5.png'),
                title: 'Cold Chamber Die Casting',
                desc: 'Cold chamber die casting melts metal in a separate furnace before casting. The molten metal is poured into a cold chamber, where a piston pushes it into the die under high pressure. The process handles high melting point metals like aluminum. The separation prevents contamination and extends die life. This type of die casting produces car engine parts, aircraft components, and electronic housings where strength and precision matter.',
                isExpanded: false
            },
            {
                image: require('@/assets/process/6.png'),
                title: 'Hot Chamber Die Casting',
                desc: 'Hot chamber, or gooseneck casting, connects the melting furnace directly to the casting machine. A piston pulls molten metal from the furnace and injects it straight into the die. This creates faster cycle times and reduces waste since the metal stays hot throughout the process. The process suits low melting point metals like zinc, magnesium alloys. The direct connection allows efficient high-volume production of toys, hardware, decorative items, and small mechanical parts.',
                isExpanded: false
            },
            {
               image: require('@/assets/process/7.png'),
                title: 'Semi-solid Die Casting',
                desc: 'Semi-solid die casting uses metal in a paste-like state between liquid and solid. The metal is heated to this semi-solid condition, then slowly pushed into the mold with less turbulence than liquid metal. This process reduces porosity and creates stronger parts with better surface finish. Semi-solid casting applies to aluminum and magnesium alloys effectively. The controlled flow produces automotive parts, aerospace components, and applications that need high strength and quality.',
                isExpanded: false
            },
        ])

        const toggleDesc = (index) => {
            serviceList.value[index].isExpanded = !serviceList.value[index].isExpanded
        }

        return { serviceList, toggleDesc }
    },
}
</script>

<style scoped>
.cnc-services-section {
    width: 100% !important;
    background-color: #f0f3f4 !important;
    padding: 76px 20px;
    position: relative !important;
    z-index: 1;
}
.container {
    max-width: 1200px;
    margin: 0 auto !important;
    width: 100%;
    display: block;
}

.section-title {
    font-size: 29px !important;
    font-weight: 600 !important;
    color: #444 !important;
    text-align: center;
    margin-bottom: 30px;
    position: relative;
}

.services-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 40px;
    width: 100%;
    box-sizing: border-box;
    align-items: start;
}

.service-card {
    background: #fff;
    border-radius: 0;
    overflow: hidden;
    border: 1px solid #e8e8e8;
    transition: box-shadow 0.2s ease;
    display: flex;
    flex-direction: column;
    height: auto;
    cursor: pointer;
    box-sizing: border-box;
}

.service-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.card-image {
    width: 100%;
    height: 254px;
    overflow: hidden;
    flex-shrink: 0;
}

.card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.card-content {
    padding: 20px;
    display: flex;
    flex-direction: column;
    /* 已移除 flex: 1; */
}

.card-title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 1.3;
    flex-shrink: 0;
    height: 42px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
}

.card-desc-wrapper {
    display: flex;
    flex-direction: column;
}

.card-desc {
    font-size: 16px;
    color: #6b7280;
    font-weight: 600;
    line-height: 1.6;
    margin: 0 0 8px 0;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    transition: all 0.3s ease;
}

.card-desc.expanded {
    -webkit-line-clamp: unset;
    display: block;
}

.toggle-btn {
    align-self: flex-start;
    background: none;
    border: none;
    color: #16bc9c;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
    transition: color 0.2s;
}

.toggle-btn:hover {
    color: #13a68a;
    text-decoration: underline;
}

.action-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
}

.btn-primary {
    padding: 12px 30px;
    border: none;
    background: #16bc9c !important;
    color: #fff !important;
    font-size: 16px;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.2s ease;
}

.btn-primary:hover {
    background: #13a68a !important;
}

@media (max-width: 992px) {
    .services-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 640px) {
    .services-grid {
        grid-template-columns: 1fr;
    }
    .action-buttons {
        flex-direction: column;
        width: 100%;
    }
    .btn-primary {
        width: 100%;
        justify-content: center;
    }
}
</style>